import React from 'react'
import axios from 'axios'

import Button from '../Form/Button'

export default class EditAnexo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ficha: {
                idProcesso: this.props.match.params.id,
                idAnexo: this.props.location.search.slice(1),
                tipo: '',
                name: ''
            },
            button: false
        }
    }

    componentDidMount() {
        if (localStorage.tipo !== "interno") {
            window.location = '/'
        }
        const url = `/api/anexos/getAnexo`
        const ficha = this.state.ficha
        axios.post(url, ficha)
            .then(resp => {
                ficha.name = resp.data.name
                ficha.tipo = resp.data.tipo
                this.setState({ ficha })
            })
            .catch(error => {
                alert(error)
            })
    }

    save() {
        const url = `/api/anexos/editAnexo`
        const ficha = this.state.ficha
        axios.post(url, ficha)
            .then(resp => {
                alert(resp.data)
                window.location = `/documentosPaf/${this.props.match.params.id}`
            })
            .catch(error => {
                alert(error)
            })
    }

    updateName(event) {
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
    }

    render() {
        return (
            <div className="container mx-auto text-center">
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "2vh" }}>
                    <div style={{
                        textAlign: "left", color: "#484848",
                        marginRight: "2vw"
                    }}>
                        <div>Tipo de Documento:</div>
                        <input type="text" name="tipo" value={this.state.ficha?.tipo}
                            onChange={e => this.updateName(e)}
                            style={{
                                width: "25vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                                borderRadius: "5px", minHeight: "5px"
                            }} />
                        <div>Nome para o arquivo:</div>
                        <input type="text" name="name" value={this.state.ficha.name}
                            onChange={e => this.updateName(e)}
                            style={{
                                width: "25vw", backgroundColor: "#00000000", border: "1px solid #00000029",
                                borderRadius: "5px", minHeight: "5px"
                            }} />
                    </div>
                </div>
                <Button onClick={e => this.save(e)} disabled={this.state.button} />
            </div>
        )
    }
}